import { useUserProfile } from '../core/TTgraphql';
import { getActiveLeaseForRenter } from '../services/utilities/getActiveLeaseForRenter';

export const useGetActiveLeaseForRenter = () => {
  const { user } = useUserProfile({}, false);
  const lease = getActiveLeaseForRenter(user);

  return lease;
};
